<template>
  <Modal v-model="visible" width="800px" :title="formData.id?'编辑':'新增'" :footer-hide="true" :mask-closable="false" class="my-modal top">
    <Form ref="form" :model="formData" :label-width="110" class="page-form less formGauge">
      <FormItem prop="themeName" label="培训专题" class="full" :rules="$units.formRule.required('请输入培训专题')">
        <Input v-model="formData.themeName" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="description" label="培训简介" class="full">
        <Input v-model="formData.description" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="address" label="培训地址" class="full">
        <Input v-model="formData.address" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="startTime" label="培训开始时间" class="less" :rules="$units.formRule.objRequired('请选择培训开始时间')">
        <DatePicker type="datetime" v-model="formData.startTime" format="yyyy-MM-dd HH:mm" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="endTime" label="培训结束时间" class="less" :rules="$units.formRule.objRequired('请选择培训结束时间')">
        <DatePicker type="datetime" v-model="formData.endTime" format="yyyy-MM-dd HH:mm" placeholder="请选择"></DatePicker>
      </FormItem>
      <FormItem prop="teachers" label="培训老师">
        <Input v-model="formData.teachers" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="timeLength" label="培训时长" :rules="$units.formRule.num('请选择正确的培训时长')">
        <Input v-model="formData.timeLength" placeholder="请输入" style="width:180px" />（分钟）
      </FormItem>
			<FormItem prop="content" label="培训内容" class="full editor-item">
				<editor ref="editorRef" v-model="formData.content"></editor>
			</FormItem>

		</Form>
		<div class="ivu-modal-footer">
			<Button type="text" @click="visible=false">取消</Button>
			<Button type="primary" @click="submit" :loading="loading">提交</Button>
		</div>
	</Modal>
</template>

<script>
	import editor from '@/components/commons/editor';
	export default {
		components: {
			editor
		},
		props: [],
		data() {
			return {
				visible: false,
				loading: false,
				formData: {
					themeName: "",
					content: "",
					address: "",
					startTime: null,
					endTime: null,
					teachers: "",
					timeLength: null,
					description: ''
				},
			};
		},
		created() {},
		methods: {
			validateAge(rule, value, callback) {
				if (!Number.isInteger(value) || value <= 0) {
					callback(new Error('请输入正整数'));
				} else {
					callback();
				}
			},
			open(data = {}) {
				this.$refs.form && this.$refs.form.resetFields();
				const formData = JSON.parse(JSON.stringify(data));
				this.formData = formData;
				this.visible = true;
				if (data.id) {
					this.getDetail();
				} else {
					this.$refs.editorRef && this.$refs.editorRef.initHtml('');
				}
			},
			getDetail() {
				this.$http({
					type: "GET",
					url: "/buz/train/read/detail",
					data: {
						id: this.formData.id
					}
				}).then(res => {
					this.formData = res.data;
					this.$refs.editorRef && this.$refs.editorRef.initHtml(res.data.content);
				})
			},
			submit() {
				console.log("validate")
				this.$refs.form.validate().then(isok => {
					if (!isok) {
						return;
					}
					const formData = JSON.parse(JSON.stringify(this.formData));
					formData.startTime = this.$units.formatDate(formData.startTime, "yyyy-MM-dd hh:mm");
					formData.endTime = this.$units.formatDate(formData.endTime, "yyyy-MM-dd hh:mm");
					if (formData.startTime > formData.endTime) {
						this.$notice.error("培训开始时间不能大于结束时间");
						return;
					}
					if (this.loading) {
						return;
					}
					this.loading = true;
					this.$http({
						type: "POST",
						url: formData.id ? "/buz/train/edit" : "/buz/train/add",
						data: formData,
          	apiPermissionCode:'operate_5_1'
					}).then(res => {
						this.$notice.success("提交成功");
						this.visible = false;
						this.$emit("suceess")
					}).finally(res => {
						this.loading = false;
					});

				})
			},
		},

	};
</script>
<style lang="scss" scoped>
.editor-item {
  z-index: 1;
  position: relative;
}
</style>
